// extracted by mini-css-extract-plugin
export default {"wrap":"WE-z","fullWidth":"XE-z","hideOnDesktop":"YE-z","content":"ZE-z","hasOpenedNav":"_E-z","crumbsList":"aF-z","dropdownsWrap":"bF-z"};